import { Boundaries } from "@planzone/core";
import { taskStatusCreationError } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  error: taskStatusCreationError,
  canCreateStatus: false,
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
    error: initialState.error,
    canCreateStatus: false,
  };
}

function handleFailure(
  state: State,
  { error }: Boundaries["createTaskStatus"]["failure"],
): State {
  return {
    ...state,
    error,
    request: { ...initialState.request, isFailure: true },
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createTaskStatusRequested]: handleRequest,
    [events.createTaskStatusSucceeded]: handleSuccess,
    [events.createTaskStatusFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
